import { Link, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import userImage from "../assets/user.svg";
import buttonSX from './muiStyles/buttonSX.js'



import { Button } from "@mui/material/";

// const buttonSX = {
//   backgroundColor: "#3834DC",
//   textTransform: "none",
//   borderRadius: "10px",
//   fontWeight: "600",
//   fontSize: "1.1rem",
//   "&:hover": {
//       backgroundColor: "rgb(56, 52, 220, 0.85)",
//     },
// };

const QuestionIntro = ({ userData }) => {
  const navigate = useNavigate();

  const handleQuestionaire = () => {
    navigate("/questions");
  };
  return (
    // <AnimatePresence >
    <div className="wrapper">
      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ ease: "easeInOut", duration: 1 }}
        className="questionIntro"
      >
        <h2>
          Mentor <span>match</span>
        </h2>
        <div className="userImage">
          <img src={userImage} alt="User outline" />
        </div>
        <div className="textContent">
          {userData.mentorType === "Mentor" ? (
            <>
              <p>
                We’ll ask you several questions to learn about you so we can match you with mentees. 
              </p>
              <p>
                You’ll also have a chance to upload your bio and photo so they can get to know you.
              </p>
            </>
          ) : (
            <>
              <p>
                We’ll ask you several questions to learn about you so we can
                match you with 3 mentors.
              </p>
              <p>
                You can read their profiles and decide who is the best match for
                you!
              </p>
            </>
          )}
        </div>

        <Button
          sx={buttonSX}
          onClick={handleQuestionaire}
          className="button"
          variant="contained"
        >
          Let's go!
        </Button>
      </motion.section>
    </div>
    // </AnimatePresence>
  );
};

export default QuestionIntro;
